import script from "./InformationModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationModal.vue?vue&type=script&lang=ts&setup=true"

import "./InformationModal.vue?vue&type=style&index=0&id=42a52e45&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a52e45"]])

export default __exports__